import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  currentSpeech: string = '';
  currentTab: string = '/';
  title = 'angular-test';

  changeTab(str: string) {
    this.currentTab = str;
  }

  changeSpeech(id: string) {
    this.currentSpeech = id;
  }
}
